import { useEffect, useMemo, useRef } from 'react';
import { deepEqual } from 'fast-equals';
import { fillEmptyValues } from '../form-values';
import { normalizeValues } from './normalize-values';
import { getAutofillValues } from '../../components/form/autofill';
export const useFormValues = (form, values, onChange, config, enableAutofill) => {
    const hasAutofilled = useRef(false);
    const normalizedValues = useMemo(() => {
        const filled = fillEmptyValues(form, values);
        if (enableAutofill && !hasAutofilled.current && config?.userData) {
            hasAutofilled.current = true;
            const autofill = getAutofillValues(form, config);
            for (const [key, value] of Object.entries(autofill)) {
                if (filled[key] == null) {
                    filled[key] = value;
                }
            }
        }
        return normalizeValues(form, filled, true, config);
    }, [form, values, config, enableAutofill]);
    useEffect(() => {
        const hasAnyValueChanged = !deepEqual(normalizedValues, values);
        if (hasAnyValueChanged) {
            onChange?.(normalizedValues);
        }
    }, [values, normalizedValues, onChange]);
    return normalizedValues;
};
//# sourceMappingURL=use-form-values.js.map